import React, { useState } from 'react'
import { AgChartsReact } from 'ag-charts-react';

const PartnersAccountsChart = ({ data }) => {
  const chartData = {
    data: data,
    series: [{ type: 'bar', xKey: 'month', yKey: 'accounts' }],
  }

  return (
    <AgChartsReact options={chartData} />
  );
}

export default PartnersAccountsChart;